/*
 * B2B checkout gate
 * -----------------
 * Disables the checkout button (and shows a notice) for logged-in ACCEPTED-RETAILER
 * customers whose cart total is below the required minimum order amount.
 *
 * The initial state is rendered server-side in Liquid. This element keeps that state
 * in sync after AJAX cart updates by listening to the theme's `cart:change` event,
 * which carries the up-to-date cart payload (`event.detail.cart.total_price`).
 */
(function () {
  if (window.customElements.get("b2b-checkout-gate")) {
    return;
  }

  var MINIMUM_TOKEN = /\{\{\s*minimum\s*\}\}/g;
  var REMAINING_TOKEN = /\{\{\s*remaining\s*\}\}/g;

  var B2BCheckoutGate = class extends HTMLElement {
    connectedCallback() {
      this.minimum = parseInt(this.getAttribute("data-minimum") || "0", 10);
      this.isB2b = this.getAttribute("data-b2b") === "true";
      this.messageTemplate = this.getAttribute("data-message") || "";

      this._formatter = this._buildFormatter();
      this._onCartChange = this._onCartChange.bind(this);
      this._onSubmit = this._onSubmit.bind(this);

      document.addEventListener("cart:change", this._onCartChange);

      this._form = this._getCheckoutButton() ? this._getCheckoutButton().closest("form") : null;
      if (this._form) {
        this._form.addEventListener("submit", this._onSubmit);
      }

      this.update(parseInt(this.getAttribute("data-total") || "0", 10));
    }

    disconnectedCallback() {
      document.removeEventListener("cart:change", this._onCartChange);
      if (this._form) {
        this._form.removeEventListener("submit", this._onSubmit);
      }
    }

    _buildFormatter() {
      try {
        var locale = (window.Shopify && window.Shopify.locale) || document.documentElement.lang || "en";
        return new Intl.NumberFormat(locale, { style: "currency", currency: "EUR" });
      } catch (e) {
        return null;
      }
    }

    _getCheckoutButton() {
      return this.querySelector('[name="checkout"]');
    }

    _getNotice() {
      return this.querySelector("[data-b2b-notice]");
    }

    _onCartChange(event) {
      var cart = event && event.detail && event.detail.cart;
      if (!cart || typeof cart.total_price !== "number") {
        return;
      }
      this.update(cart.total_price);
    }

    _onSubmit(event) {
      if (this._blocked) {
        event.preventDefault();
      }
    }

    update(totalPrice) {
      var blocked = this.isB2b && this.minimum > 0 && typeof totalPrice === "number" && totalPrice < this.minimum;
      this._blocked = blocked;

      var button = this._getCheckoutButton();
      if (button) {
        button.disabled = blocked;
        button.toggleAttribute("disabled", blocked);
        button.setAttribute("aria-disabled", blocked ? "true" : "false");
      }

      var notice = this._getNotice();
      if (notice) {
        notice.hidden = !blocked;
        if (blocked) {
          var remaining = Math.max(0, this.minimum - totalPrice);
          notice.innerHTML = this._renderMessage(remaining);
        }
      }
    }

    _renderMessage(remaining) {
      var minimumDisplay = this._format(this.minimum);
      var remainingDisplay = this._format(remaining);
      return this.messageTemplate
        .replace(MINIMUM_TOKEN, minimumDisplay)
        .replace(REMAINING_TOKEN, remainingDisplay);
    }

    _format(amountInSubunits) {
      var amount = amountInSubunits / 100;
      if (this._formatter) {
        return this._formatter.format(amount);
      }
      return "€" + amount.toFixed(2);
    }
  };

  window.customElements.define("b2b-checkout-gate", B2BCheckoutGate);
})();
